module.exports = __webpack_public_path__ + "static/media/loader.12d9c8ca.svg";